// src/pages/Clients/ClientsDashboard.jsx
import React, { useEffect, useState } from "react";
import { Tabs, Button, Space, App } from "antd";
import { ArrowLeftOutlined } from "@ant-design/icons";
import { useDispatch } from "react-redux";
import { useNavigate } from "react-router-dom";
import {
  fetchClients,
  fetchClientUsers,
  fetchEmailSchedules,
} from "./clientsSlice";
import "./clientsDashboard.css";
import ClientsTab from "./components/ClientsTab";
import ClientUsersTab from "./components/ClientUsersTab";
import EmailScheduleTab from "./components/EmailScheduleTab";
import LeavePolicyTab from "./components/LeavePolicyTab";
import ClientFormModal from "./components/ClientFormModal";
import ClientUserModal from "./components/ClientUserModal";
import EmailScheduleModal from "./components/EmailScheduleModal";
import LeavePolicyModal from "./components/LeavePolicyModal";
import { getAccessType } from "../../lib/functions";

const ClientsDashboard = ({ authInfo }) => {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const { message } = App.useApp();
  const [activeKey, setActiveKey] = useState("1");

  const [clientModalOpen, setClientModalOpen] = useState(false);
  const [clientEdit, setClientEdit] = useState(null);

  const [clientUserModalOpen, setClientUserModalOpen] = useState(false);
  const [clientUserEdit, setClientUserEdit] = useState(null);

  const [scheduleModalOpen, setScheduleModalOpen] = useState(false);
  const [scheduleEdit, setScheduleEdit] = useState(null);

  const [policyModalOpen, setPolicyModalOpen] = useState(false);
  const [policyEdit, setPolicyEdit] = useState(null);
  let [access_type, access_type_set] = useState("");

  useEffect(() => {
    const access = getAccessType("clients_entry");
    access_type_set(access);
  }, []);

  useEffect(() => {
    // initial loads
    dispatch(fetchClients());
    dispatch(fetchClientUsers());
    dispatch(fetchEmailSchedules());
  }, [dispatch]);

  const items = [
    {
      key: "1",
      label: "Clients",
      children: (
        <ClientsTab
          onCreate={() => { setClientEdit(null); setClientModalOpen(true); }}
          onEdit={(row) => { setClientEdit(row); setClientModalOpen(true); }}
        />
      ),
    },
    {
      key: "2",
      label: "Client Users",
      children: (
        <ClientUsersTab
          onCreate={() => { setClientUserEdit(null); setClientUserModalOpen(true); }}
          onEdit={(row) => { setClientUserEdit(row); setClientUserModalOpen(true); }}
        />
      ),
    },
    {
      key: "3",
      label: "Email Schedule",
      children: (
        <EmailScheduleTab
          onCreate={() => { setScheduleEdit(null); setScheduleModalOpen(true); }}
          onEdit={(row) => { setScheduleEdit(row); setScheduleModalOpen(true); }}
        />
      ),
    },
    {
      key: "4",
      label: "Client Leave Policy",
      children: (
        <LeavePolicyTab
          onCreate={() => { setPolicyEdit(null); setPolicyModalOpen(true); }}
          onEdit={(row) => { setPolicyEdit(row); setPolicyModalOpen(true); }}
        />
      ),
    },
  ];

  return (
    <div className="clients-dashboard">
      <Space style={{ width: "100%", justifyContent: "space-between", marginBottom: 12 }}>
        <Button
          type="text"
          icon={<ArrowLeftOutlined style={{ fontSize: 18 }} />}
          onClick={() => navigate(-1)}
          data-testid="clients-back-button"
        />
        <Space>
        {access_type == "WRITE" && <>
          {activeKey === "1" && <Button type="primary" onClick={() => { setClientEdit(null); setClientModalOpen(true); }}>New Client</Button>}
          {activeKey === "2" && <Button type="primary" onClick={() => { setClientUserEdit(null); setClientUserModalOpen(true); }}>New Client User</Button>}
          {activeKey === "3" && <Button type="primary" onClick={() => { setScheduleEdit(null); setScheduleModalOpen(true); }}>New Email Schedule</Button>}
          {activeKey === "4" && <Button type="primary" onClick={() => { setPolicyEdit(null); setPolicyModalOpen(true); }}>Add Leave Policy</Button>}
        </>}
        </Space>
      </Space>

      <Tabs
        activeKey={activeKey}
        onChange={setActiveKey}
        items={items}
      />

      {/* Modals */}
      <ClientFormModal open={clientModalOpen} onClose={() => setClientModalOpen(false)} edit={clientEdit} authInfo={authInfo} />
      <ClientUserModal open={clientUserModalOpen} onClose={() => setClientUserModalOpen(false)} edit={clientUserEdit} authInfo={authInfo} />
      <EmailScheduleModal open={scheduleModalOpen} onClose={() => setScheduleModalOpen(false)} edit={scheduleEdit} authInfo={authInfo} />
      <LeavePolicyModal open={policyModalOpen} onClose={() => setPolicyModalOpen(false)} edit={policyEdit} authInfo={authInfo} />
    </div>
  );
};

export default ClientsDashboard;
